import KeyConnector from './KeyConnector';

export default KeyConnector;
